import styled from 'styled-components';
import { Button } from 'ui/button';
import { H2, H4, spacing } from 'ui/theme';

import { MainLayoutWrapper } from '../Styled';

export const IndexPageContainer = styled(MainLayoutWrapper)`
  align-items: center;
  flex-direction: column;
  padding-top: ${spacing.x4};
  row-gap: ${spacing.x3};
  padding-bottom: 15%;
`;

export const IndexPageTitle = styled(H2)`
  margin-bottom: 0;
`;

export const IndexPageCreateNewContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.plusHalf};
`;
export const IndexPageCreateNewText = styled(H4)`
  margin-bottom: 0;
`;
export const IndexPageCreationButton = styled(Button)`
  align-self: center;
  width: max-content;
`;
